/* eslint-disable */
export default {
  unknown: 'Unbekannt',
  multipleMatches: 'Mehrfa. Übereins.',
  anonymous: 'Anonym',
  none: 'Kein',
} as const;

// @key: @#@"unknown"@#@ @source: @#@"Unknown"@#@
// @key: @#@"multipleMatches"@#@ @source: @#@"Multiple matches"@#@
// @key: @#@"anonymous"@#@ @source: @#@"Anonymous"@#@
// @key: @#@"none"@#@ @source: @#@"None"@#@
